module.exports = __webpack_public_path__ + "static/media/trainingsImg.f79e8daa.jpg";